import { StateDataContext } from 'containers/Common/StateDataContext';
import { useContext, useMemo } from 'react';
import i18n from 'i18n';
import { startCase } from 'lodash';
import { SummarySectionData } from 'components/FlowSummarySection/FlowSummarySection';

export type TrackingSummaryStateContentModel = {
  trackingSummaryData?: SummarySectionData;
};

export const useTrackingSummaryStateContentModel = (
  supportConversionTrackingType: boolean
) => {
  const { data } = useContext(StateDataContext);

  const trackingSummaryData = useMemo(() => {
    if (!data) {
      return;
    }

    const { conversionTracking, convTrackEvent, viewTrackingCodes } = data;

    const conversionTrackingContent = conversionTracking
      ? [
          {
            label: i18n.t('campaignSummary.labels.conversionTracking'),
            value: conversionTracking.label
          }
        ]
      : undefined;

    if (supportConversionTrackingType && conversionTrackingContent) {
      conversionTrackingContent.push({
        label: i18n.t('campaignSummary.labels.convTrackEvent'),
        value: i18n.t(
          `campaignSummary.labels.convTrackEvent${startCase(convTrackEvent)}`
        )
      });
    }
    return {
      conversionTracking: conversionTracking
        ? {
            title: i18n.t('campaignSummary.titles.conversionTracking'),
            content: conversionTrackingContent
          }
        : undefined,
      viewTrackingCodes:
        viewTrackingCodes && viewTrackingCodes.length > 0
          ? {
              title: i18n.t('campaignSummary.titles.trackingCodes'),
              content: [
                {
                  label: i18n.t('campaignSummary.labels.trackingCodes'),
                  value: viewTrackingCodes
                    .map((code) => {
                      return code.trackingCode;
                    })
                    .join('\r\n')
                }
              ]
            }
          : undefined
    };
  }, [data, supportConversionTrackingType]);

  return {
    trackingSummaryData
  };
};
